import apiRequest from '../apis/api-request';
import commonParams from '../components/commonParams';
import { selectAuthToken } from '../redux/reducers/authReducers';
import { store } from '../redux/store';

const inspectionService = {

    getInspectionProgress: async (data) => {
        const token = selectAuthToken(store.getState());
        const params = commonParams(data);
        return apiRequest({
            method: "GET",
            url: `/api/inspection/progress${params}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    getSectionProgress: async ({inspection_id}) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "GET",
            url: `/api/inspection/section/progress?inspection_id=${inspection_id}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    getQuestionProgress: async ({inspection_id, section_id}) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "GET",
            url: `/api/inspection/question/progress?inspection_id=${inspection_id}&section_id=${section_id}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    insertQuestionActionData: async (data) => {
        const token = selectAuthToken(store.getState())
        return apiRequest({
            method:"POST",
            url: `/api/sync/insert/bulkaction`,
            data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    getRemarkData: async ({inspection_id, question_id}) => {
        const token = selectAuthToken(store.getState())
        return apiRequest({
            method:"GET",
            url: `/api/inspection/question/remarks?inspection_id=${inspection_id}&question_id=${question_id}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    exportInspectionReport: async (data) => {
        const token = selectAuthToken(store.getState())
        return apiRequest({
            method:"POST",
            url: `/api/impex/questions`,
            data,
            headers: {
                Authorization: "Bearer " + token
            }
        });
    },

};

export default inspectionService;